import { render, staticRenderFns } from "./postUserIcon.vue?vue&type=template&id=4fdaaedc&"
import script from "./postUserIcon.vue?vue&type=script&lang=js&"
export * from "./postUserIcon.vue?vue&type=script&lang=js&"
import style0 from "./postUserIcon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports